<template>
  <div class="grid grid-cols-1 gap-4">
    <picking-orders-menu />
    <picking-orders-table v-on:additem="(orderid) => { openModal(orderid) }" />
    <picking-order-boxes-table :selectedorder="selectedorder"/>
    <dynamic-form v-on:toggle-form="closeModal" v-if="addpickingitemmodal" formtype='wmsaddpickingitem' :basedata="basedata"/>
  </div>
</template>

<script>
import PickingOrdersTable from '@/components/wms/PickingTable'
import PickingOrdersMenu from '@/components/wms/PickingMenu'
import PickingOrderBoxesTable from '@/components/wms/PickingOrderBoxesTable'
import DynamicForm from '@/components/DynamicForm/DynamicForm'

export default {
  name: 'wms-picking',
  components: { PickingOrdersMenu, PickingOrdersTable, PickingOrderBoxesTable, DynamicForm },
  data() {
    return {
      addpickingitemmodal: false,
      selectedorder: null,
      basedata: {
        orderid: 0
      }
    }
  },

  methods: {
    closeModal() {
      this.addpickingitemmodal = false
    },
    openModal(orderid) {
      this.basedata.orderid = orderid
      this.addpickingitemmodal = true
    },
    selectOrder(orderid) {
      this.selectedorder = orderid
    }
  }
}
</script>
